function cleanAndSetFeatureFlags(data){
    for (let flag of data){
        let flagString = flag.enabledFor.toString();
        let valid = flagString.replaceAll(/'/g, '"');
        flag.enabledFor = JSON.parse(valid);
    }
    return data;
}

export {cleanAndSetFeatureFlags};